/** Inverse of videoTimeToClipTime: map an output-clip time to the source
 *  video timeline defined by the kept intervals. Past-the-end times clamp
 *  to the last interval's end. */
export function clipTimeToVideoTime(
  clipTime: number,
  intervals: Array<{ startTime: number; endTime: number }>,
): number {
  let acc = 0;
  for (const iv of intervals) {
    const len = iv.endTime - iv.startTime;
    if (clipTime <= acc + len) return iv.startTime + Math.max(0, clipTime - acc);
    acc += len;
  }
  return intervals.length ? intervals[intervals.length - 1].endTime : 0;
}
